<template>
	<div>
		<div class="creat_ttk">
				<div class="f-wh-4-s1">
					<div class="creat_outk">
						<h6>天气环境设置</h6>
						<form id="creatForm" class="creat_form" name="creatForm">
							<p>
								<label>温度：</label>
								<select>
									<option selected hidden disabled value="">请选择设置的温度</option>
									<option>11</option>
									<option>22</option>
								</select>
							</p>
							<p>
								<label>湿度：</label>
								<select>
									<option selected hidden disabled value="">请选择设置的湿度</option>
									<option>11</option>
									<option>22</option>
								</select>
							</p>
							<p>
								<label>气压：</label>
								<select>
									<option selected hidden disabled value="">请选择设置的气压</option>
									<option>11</option>
									<option>22</option>
								</select>
							</p>
							<p>
								<label>风度：</label>
								<select>
									<option selected hidden disabled value="">请选择设置的风度</option>
									<option>11</option>
									<option>22</option>
								</select>
							</p>
							<p>
								<label>风向：</label>
								<select>
									<option selected hidden disabled value="">请选择设置的风向</option>
									<option>11</option>
									<option>22</option>
								</select>
							</p>
							<p>
								<label>能见度：</label>
								<select>
									<option selected hidden disabled value="">请选择设置的能见度</option>
									<option>11</option>
									<option>22</option>
								</select>
							</p>
							<button class="submit_task" @click="closedig">完成设置</button>
						</form>
					</div>
				</div>
		</div>
	</div>
</template>

<script>
	export default {
		methods:{
			closedig(){
				this.$emit('func2',false)
			},
		}
	}
</script>

<style scoped="scoped">
	.creat_form p label{color: #ffffff; width: 4em; text-align: right; display: inline-block;}
</style>
